import moment from "moment";
import { Badge } from "primereact/badge";
import { FcShop } from "react-icons/fc";
import { HiMiniXMark } from "react-icons/hi2";
import { IoMdCheckmark } from "react-icons/io";
import { LazyLoadImage } from "react-lazy-load-image-component";
import DropdownMenubar from "../Components/Menubar/DropdownMenubar";

const DD = (MenuItems) => {
  return (
    <div className="p-3">
      <DropdownMenubar
        menuItem={[
          {
            label: "Action",
            items: MenuItems,
          },
        ]}
      />
    </div>
  );
};

const getVendorInfo = (row, handleCellClick) => {
  return DD([
    {
      label: "APPROVE",
      icon: (
        <div className="  text-white  rounded-full bg-green-600">
          {" "}
          <IoMdCheckmark className="" />
        </div>
      ),

      command: () => {
        handleCellClick(row, "Approved");
      },
    },
    {
      label: "REJECTED ",
      icon: (
        <div className="  text-white  rounded-full bg-red-600">
          {" "}
          <HiMiniXMark className="" />
        </div>
      ),
      command: () => {
        handleCellClick(row, "Rejected");
      },
    },
    // {
    //   label: "Business Off",
    //   icon: (
    //     <div className="  text-white  rounded-full bg-red-600">
    //       {" "}
    //       <HiMiniXMark className="" />
    //     </div>
    //   ),
    //   command: () => {
    //     handleCellClick(row, "Business Off");
    //   },
    // },
    // {
    //   label: "Blocked",
    //   icon: (
    //     <div className="  text-white  rounded-full bg-red-600">
    //       {" "}
    //       <HiMiniXMark className="" />
    //     </div>
    //   ),
    //   command: () => {
    //     handleCellClick(row, "Blocked");
    //   },
    // },
  ]);
};

export const columns = [
  {
    field: "profile_image",
    header: "Image",
    accessor: (row) => (
      <div className=" w-20 ">
        <div className="overflow-hidden ">
          {row?.profile_image ? (
            <LazyLoadImage
              src={row?.profile_image}
              alt="img"
              loading="lazy"
              effect="blur"
              wrapperProps={{
                style: { transitionDelay: "1s" },
              }}
              className="rounded-full w-20 h-20"
            />
          ) : (
            <div className="rounded-full w-20 h-20 bg-[#d2d2d2] flex justify-center items-center">
              <FcShop className="text-[3rem]  text-[#02aabd93]" />
            </div>
          )}
        </div>
      </div>
    ),
  },
  {
    field: "first_name",
    header: "Name",
    accessor: (row) => (
      <>
        <div>
          <p>{row?.first_name}</p>
        </div>
      </>
    ),
  },
  {
    field: "gender",
    header: "Gender",
    accessor: (row) => (
      <>
        <div className="">
          <p>{row?.gender}</p>
        </div>
      </>
    ),
  },
  {
    field: "email",
    header: "Email",
    accessor: (row) => (
      <>
        <div className="">{row?.email}</div>
      </>
    ),
  },
  {
    field: "phone_number",
    header: "Phone Number",
    accessor: (row) => (
      <div className="w-fit">
        <p className="w-full text-nowrap text-center">{row?.phone_number}</p>
      </div>
    ),
  },

  {
    field: "country",
    header: "Address",
    accessor: (row) => (
      <div className="w-fit">
        <p className="w-full text-nowrap text-center">{row?.country?.name}</p>
        <p className="w-full text-nowrap text-center">{row?.city?.name}</p>
      </div>
    ),
  },
  {
    field: "status",
    header: "Status",
    accessor: (row, handleCellClick) => (
      <>
        {row?.status && (
          <Badge
            className="w-[6rem]"
            severity={
              row?.status === "Approved"
                ? "success"
                : row?.status === "Pending"
                ? "warning"
                : "danger"
            }
            value={row?.status}
          />
        )}
      </>
    ),
  },
  {
    field: "action",
    header: "Action",
    accessor: (row, handleCellClick) => getVendorInfo(row, handleCellClick),
  },
];

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

export const filters = [
  {
    filterType: "Filter by A/U",
    inputName: "status",
    options: [
      {
        name: "Approved",
        code: "Approved",
      },
      {
        name: "Rejected",
        code: "Rejected",
      },
      {
        name: "Pending",
        code: "Pending",
      },
    ],
  },
];
